module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kxduL"))).then(() => parcelRequire('hEqeo'));